import { render } from "./BackgroundImage.vue?vue&type=template&id=1a4646d0&ts=true"
import script from "./BackgroundImage.vue?vue&type=script&lang=ts"
export * from "./BackgroundImage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/jh8oh.github.io/jh8oh.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__